module.exports = __webpack_public_path__ + "img/12.03472785.png";